import { createContext, useContext, useState, ReactNode } from 'react'
import Conversation from '@interfaces/conversation.interface'

interface ConversationsContextType {
  conversations: Conversation[]
  setConversations: (conversations: Conversation[] | ((prev: Conversation[]) => Conversation[])) => void
}

const ConversationsContext = createContext<ConversationsContextType | undefined>(undefined)

/**
 * Provide the conversations context
 * @param children - The children to provide the context to
 * @returns The conversations context
 */
export function ConversationsProvider({ children }: { children: ReactNode }) {
  const [conversations, setConversations] = useState<Conversation[]>([])

  return <ConversationsContext.Provider value={{ conversations, setConversations }}>{children}</ConversationsContext.Provider>
}

/**
 * Use the conversations context
 * @returns The conversations context
 */
export function useConversations() {
  const context = useContext(ConversationsContext)
  if (context === undefined) {
    throw new Error('useConversations must be used within a ConversationsProvider')
  }
  return context
}
